angular.module('cloudX').directive('editableBoolSelect', [
  'editableDirectiveFactory',
  function(editableDirectiveFactory) {
    var dir = editableDirectiveFactory({
      directiveName: 'editableBoolSelect',
      inputTpl: '<cx-bool-select ng-change="submitOnChange()"></cx-bool-select>',
      render: function() {
        this.parent.render.call(this);
      },
      autosubmit: function() {
        var self = this;
        self.scope.submitOnChange = function() {
          self.scope.$form.$submit();
        };
      },
    });
    return dir;
  },
]);
